export default "__VITE_ASSET__CXf$dpOl__"